import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Alert, TableSortLabel, Typography } from "@mui/material";
import {
  typography,
  spacing,
  colors,
} from "../../../../../../../../../assets/styles/tokens";

interface Props {
  monthTableHeadings: { [key: string]: string };
  monthTableRows: any[];
}

const RecentMonthTable = ({ monthTableHeadings, monthTableRows }: Props) => {
  const headCells = Object.entries(monthTableHeadings);

  const parsePercentage = (value: unknown): number | null => {
    if (typeof value === "number") return value;

    if (typeof value === "string") {
      const parsed = parseFloat(value.replace("%", ""));
      return Number.isFinite(parsed) ? parsed : null;
    }

    return null;
  };
  const formatPercentage = (value: number, digits = 1) =>
    `${value.toFixed(digits)}%`;

  const getTargetAlertConfig = (value: number) => {
    if (value <= 50) {
      return {
        severity: "error" as const,
        color: colors.Error[600].$value,
        icon: false,
      };
    }

    if (value <= 90) {
      return {
        severity: "warning" as const,
        color: colors.Warning[600].$value,
        icon: false,
      };
    }

    return {
      severity: "success" as const,
      color: colors.Success[600].$value,
      icon: false,
    };
  };

  return (
    <>
      <Table size="small">
        <TableHead sx={{ background: colors.GrayLightMode[100].$value }}>
          <TableRow>
            {headCells.map(([_, value], index) => (
              <TableCell
                key={index}
                align="left"
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: typography.Size.Text.xs.$value,
                  fontWeight: typography.Font_weight.Regular.$value,
                  paddingX: spacing.Spacing.sm.$value,
                }}
              >
                <TableSortLabel>
                  {value && typeof value === "string" ? value : ""}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {monthTableRows.map((row) => (
            <React.Fragment key={row.cron_id}>
              <TableRow
                sx={{
                  "& > *": {
                    borderBottom:
                      "1px solid " +
                      colors.GrayLightMode[200].$value +
                      "!important",
                  },
                }}
              >
                {headCells.map(([key], cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    align="left"
                    sx={{
                      // whiteSpace: "nowrap",
                      fontSize: typography.Size.Text.xs.$value,
                      fontWeight: typography.Font_weight.Regular.$value,
                      paddingX: spacing.Spacing.sm.$value,
                      paddingY: spacing.Spacing.xxs.$value,
                    }}
                  >
                    {key === "metric" ? (
                      <> {row[key] ? row[key] : "N/A"}</>
                    ) : key === "actual_target" ? (
                      <Typography
                        sx={{
                          fontWeight: typography.Font_weight.Bold.$value,
                          fontSize: typography.Size.Text.xs.$value,
                        }}
                      >
                        {" "}
                        {row[key] ? row[key] : "N/A"}
                      </Typography>
                    ) : key === "gap" ? (
                      <> {row[key] ? row[key] : "N/A"}</>
                    ) : key === "attainment" ? (
                      <div className="AlertItems">
                        {(() => {
                          const value = parsePercentage(row[key]);

                          if (value === null) return <>N/A</>;

                          const { severity, color, icon } =
                            getTargetAlertConfig(value);

                          return (
                            <Alert
                              icon={icon}
                              severity={severity}
                              sx={{
                                // border: `1px solid ${border}`,
                                color: `${color}`,
                                fontWeight:
                                  typography.Font_weight.Medium.$value,
                                paddingX: spacing.Spacing.sm.$value,
                                paddingY: spacing.Spacing.none.$value,
                                fontSize: typography.Size.Text.xs.$value,
                                display: "inline-flex",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {formatPercentage(value, 1)}
                            </Alert>
                          );
                        })()}
                      </div>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default RecentMonthTable;
